import { theme } from '@acorns/web-components'
import { css } from 'styled-components'

export const publishingColors = {
  backgroundBlack: '#222B2D',
  tan: '#EADDB8',
}

/** Gradient-filled text; WebKit prefixes for Safari, standard props elsewhere. */
export const orangeGradientText = css`
  background: radial-gradient(
    64.17% 285.47% at 8.57% 35.83%,
    ${publishingColors.tan} 0%,
    ${theme.colors.dusk} 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
`

export const fonts = {
  AN_10_500_13: css`
    font-family: 'Avenir Next';
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 13px;
  `,
  AN_12_500_16: css`
    font-family: 'Avenir Next';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
  `,
  AN_14_600_22: css`
    font-family: 'Avenir Next';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  `,
  AN_16_400_24: css`
    font-family: 'Avenir Next';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  `,
  AN_16_600_24: css`
    font-family: 'Avenir Next';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  `,
  AN_18_400_26: css`
    font-family: 'Avenir Next';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
  `,
  AN_22_600_30: css`
    font-family: 'Avenir Next';
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
  `,
  AN_30_600_38: css`
    font-family: 'Avenir Next';
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 38px;
  `,
  AN_40_600_55: css`
    font-family: 'Avenir Next';
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 55px;
  `,
  AN_60_600_60: css`
    font-family: 'Avenir Next';
    font-size: 60px;
    font-style: normal;
    font-weight: 600;
    line-height: 60px;
  `,
}

export const RECAP_MEDIUM_BREAKPOINT = 900
export const RECAP_XS_BREAKPOINT = 420
